<template>
  <v-container class="px-0">
    <v-row class="justify-center mb-4">
      <v-col class="px-0">
        <div class="col-md-10 col-md-offset-1 col-xl-12">
          <table>
            <thead>
              <tr>
                <th>&nbsp;</th>
                <th v-if='showProPlanBtn'>
                  <h5>PRO</h5>
                  <div class="paymentPlan__price">
                    <div class="price-wrapper">
                      <span class="currency">$</span><span class="price">25</span><span class="period">/mo</span>
                    </div>
                    <div class="and-price">Billed Annually</div>
                  </div>
                  <a
                    v-if="showProPlanBtn"
                    class="table-btn mx-2"
                    href="/subscription/pro"
                  >SELECT</a
                  >
                  <a
                    v-else
                    class="table-btn-current-plan mx-2"
                    @click="$emit('change-plan-to-pro', 'pro')"
                  >CURRENT PLAN</a
                  >
                </th>
                <th v-if='showBusinessPlanBtn'>
                  <h5>BUSINESS</h5>
                  <div class="paymentPlan__price">
                    <div class="price-wrapper">
                      <span class="currency">$</span><span class="price">47.40</span><span class="period">/mo</span>
                    </div>
                    <div class="and-price">Billed Annually</div>
                  </div>
                  <a
                    v-if="showBusinessPlanBtn"
                     class="table-btn mx-2"
                    href="/subscription/business"
                     >SELECT</a
                   >
                   <a
                     v-else
                     class="table-btn-current-plan mx-2"
                    @click="$emit('change-plan-to-business', 'business')"
                     >CURRENT PLAN</a
                   >
                </th>
                <th v-if='showCompanyPlanBtn'>
                  <h5>COMPANY</h5>
                  <div class="paymentPlan__price">
                    <div class="price-wrapper">
                      <span class="currency">$</span><span class="price">177</span><span class="period">/mo</span>
                    </div>
                    <div class="and-price">Billed Annually</div>
                  </div>
                  <a
                    v-if="showCompanyPlanBtn"
                    class="table-btn mx-2"
                    href="/subscription/company"
                    >SELECT</a
                  >
                  <a v-else class="table-btn-current-plan mx-2">CURRENT PLAN</a>
                </th>
                <th>
                  <h5>CORPORATE</h5>
                  <div class="paymentPlan__price">
                    <div class="price-wrapper">
                      <span class="currency">$</span><span class="price">{{plans.corporate.price}}</span><span class="period">/year</span>
                    </div>
                  </div>
                  <a
                    v-if="showCorporatePlanBtn"
                    class="table-btn mx-2"
                    href="/subscription/corporate"
                    >select</a
                  >
                  <a v-else class="table-btn-current-plan mx-2"
                    >CURRENT PLAN</a>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th colspan="5">Organize</th>
              </tr>
              <tr>
                <td>Users</td>
                <td v-if='showProPlanBtn'>{{checkUnlimited(plans.pro.limitUsers)}}</td>
                <td v-if='showBusinessPlanBtn'>{{checkUnlimited(plans.business.limitUsers)}}</td>
                <td v-if='showCompanyPlanBtn'>{{checkUnlimited(plans.company.limitUsers)}}</td>
                <td>{{checkUnlimited(plans.corporate.limitUsers)}}</td>
              </tr>
              <tr>
                <td>Warehouses</td>
                <td v-if='showProPlanBtn'>{{checkUnlimited(plans.pro.limitInventories)}}</td>
                <td v-if='showBusinessPlanBtn'>{{checkUnlimited(plans.business.limitInventories)}}</td>
                <td v-if='showCompanyPlanBtn'>{{checkUnlimited(plans.company.limitInventories)}}</td>
                <td>{{checkUnlimited(plans.corporate.limitInventories)}}</td>
              </tr>
              <tr>
                <td>Items</td>
                <td v-if='showProPlanBtn'>{{checkUnlimited(plans.pro.limitItems)}}</td>
                <td v-if='showBusinessPlanBtn'>{{checkUnlimited(plans.business.limitItems)}}</td>
                <td v-if='showCompanyPlanBtn'>{{checkUnlimited(plans.company.limitItems)}}</td>
                <td>{{checkUnlimited(plans.corporate.limitItems)}}</td>
              </tr>
              <tr>
                <th colspan="5">Customize</th>
              </tr>
              <tr>
                <td>Barcodes</td>
                <td v-if='showProPlanBtn'>
                  <v-row class="justify-center align-center">
                    <span>
                      <svg preserveAspectRatio="xMidYMid meet" data-bbox="0.799 0.761 12.44 9.799" xmlns="http://www.w3.org/2000/svg" viewBox="0.799 0.761 12.44 9.799" height="11" width="14" data-type="color" role="presentation" aria-hidden="true">
                        <g>
                          <path fill="#000624" d="M4.5 8.44 11.94 1A.75.75 0 1 1 13 2.06l-8.5 8.5L1 7.06A.75.75 0 0 1 2.06 6L4.5 8.44Z" clip-rule="evenodd" fill-rule="evenodd" data-color="1"></path>
                        </g>
                      </svg>
                    </span>
                  </v-row>
                </td>
                <td v-if='showBusinessPlanBtn'>
                  <v-row class="justify-center align-center">
                    <span>
                      <svg preserveAspectRatio="xMidYMid meet" data-bbox="0.799 0.761 12.44 9.799" xmlns="http://www.w3.org/2000/svg" viewBox="0.799 0.761 12.44 9.799" height="11" width="14" data-type="color" role="presentation" aria-hidden="true">
                        <g>
                          <path fill="#000624" d="M4.5 8.44 11.94 1A.75.75 0 1 1 13 2.06l-8.5 8.5L1 7.06A.75.75 0 0 1 2.06 6L4.5 8.44Z" clip-rule="evenodd" fill-rule="evenodd" data-color="1"></path>
                        </g>
                      </svg>
                    </span>
                  </v-row>
                </td>
                <td v-if='showCompanyPlanBtn'>Custom barcode labels</td>
                <td>Custom barcode labels</td>
              </tr>
              <tr>
                <td>CSV/PDF Reporting</td>
                <td v-if='showProPlanBtn'>
                  <v-row class="justify-center align-center">
                    <span>
                      <svg preserveAspectRatio="xMidYMid meet" data-bbox="0.799 0.761 12.44 9.799" xmlns="http://www.w3.org/2000/svg" viewBox="0.799 0.761 12.44 9.799" height="11" width="14" data-type="color" role="presentation" aria-hidden="true">
                        <g>
                          <path fill="#000624" d="M4.5 8.44 11.94 1A.75.75 0 1 1 13 2.06l-8.5 8.5L1 7.06A.75.75 0 0 1 2.06 6L4.5 8.44Z" clip-rule="evenodd" fill-rule="evenodd" data-color="1"></path>
                        </g>
                      </svg>
                    </span>
                  </v-row>
                </td>
                <td v-if='showBusinessPlanBtn'>
                  <v-row class="justify-center align-center">
                    <span>
                      <svg preserveAspectRatio="xMidYMid meet" data-bbox="0.799 0.761 12.44 9.799" xmlns="http://www.w3.org/2000/svg" viewBox="0.799 0.761 12.44 9.799" height="11" width="14" data-type="color" role="presentation" aria-hidden="true">
                        <g>
                          <path fill="#000624" d="M4.5 8.44 11.94 1A.75.75 0 1 1 13 2.06l-8.5 8.5L1 7.06A.75.75 0 0 1 2.06 6L4.5 8.44Z" clip-rule="evenodd" fill-rule="evenodd" data-color="1"></path>
                        </g>
                      </svg>
                    </span>
                  </v-row>
                </td>
                <td v-if='showCompanyPlanBtn'>
                  <v-row class="justify-center align-center">
                    <span>
                      <svg preserveAspectRatio="xMidYMid meet" data-bbox="0.799 0.761 12.44 9.799" xmlns="http://www.w3.org/2000/svg" viewBox="0.799 0.761 12.44 9.799" height="11" width="14" data-type="color" role="presentation" aria-hidden="true">
                        <g>
                          <path fill="#000624" d="M4.5 8.44 11.94 1A.75.75 0 1 1 13 2.06l-8.5 8.5L1 7.06A.75.75 0 0 1 2.06 6L4.5 8.44Z" clip-rule="evenodd" fill-rule="evenodd" data-color="1"></path>
                        </g>
                      </svg>
                    </span>
                  </v-row>
                </td>
                <td>
                  <v-row class="justify-center align-center">
                    <span>
                      <svg preserveAspectRatio="xMidYMid meet" data-bbox="0.799 0.761 12.44 9.799" xmlns="http://www.w3.org/2000/svg" viewBox="0.799 0.761 12.44 9.799" height="11" width="14" data-type="color" role="presentation" aria-hidden="true">
                        <g>
                          <path fill="#000624" d="M4.5 8.44 11.94 1A.75.75 0 1 1 13 2.06l-8.5 8.5L1 7.06A.75.75 0 0 1 2.06 6L4.5 8.44Z" clip-rule="evenodd" fill-rule="evenodd" data-color="1"></path>
                        </g>
                      </svg>
                    </span>
                  </v-row>
                </td>
              </tr>
              <tr>
                <td>Alerts</td>
                <td v-if='showProPlanBtn'>
                  <v-row class="justify-center align-center">
                    <span>
                      <svg preserveAspectRatio="xMidYMid meet" data-bbox="0.799 0.761 12.44 9.799" xmlns="http://www.w3.org/2000/svg" viewBox="0.799 0.761 12.44 9.799" height="11" width="14" data-type="color" role="presentation" aria-hidden="true">
                        <g>
                          <path fill="#000624" d="M4.5 8.44 11.94 1A.75.75 0 1 1 13 2.06l-8.5 8.5L1 7.06A.75.75 0 0 1 2.06 6L4.5 8.44Z" clip-rule="evenodd" fill-rule="evenodd" data-color="1"></path>
                        </g>
                      </svg>
                    </span>
                  </v-row>
                </td>
                <td v-if='showBusinessPlanBtn'>
                  <v-row class="justify-center align-center">
                    <span>
                      <svg preserveAspectRatio="xMidYMid meet" data-bbox="0.799 0.761 12.44 9.799" xmlns="http://www.w3.org/2000/svg" viewBox="0.799 0.761 12.44 9.799" height="11" width="14" data-type="color" role="presentation" aria-hidden="true">
                        <g>
                          <path fill="#000624" d="M4.5 8.44 11.94 1A.75.75 0 1 1 13 2.06l-8.5 8.5L1 7.06A.75.75 0 0 1 2.06 6L4.5 8.44Z" clip-rule="evenodd" fill-rule="evenodd" data-color="1"></path>
                        </g>
                      </svg>
                    </span>
                  </v-row>
                </td>
                <td v-if='showCompanyPlanBtn'>
                  <v-row class="justify-center align-center">
                    <span>
                      <svg preserveAspectRatio="xMidYMid meet" data-bbox="0.799 0.761 12.44 9.799" xmlns="http://www.w3.org/2000/svg" viewBox="0.799 0.761 12.44 9.799" height="11" width="14" data-type="color" role="presentation" aria-hidden="true">
                        <g>
                          <path fill="#000624" d="M4.5 8.44 11.94 1A.75.75 0 1 1 13 2.06l-8.5 8.5L1 7.06A.75.75 0 0 1 2.06 6L4.5 8.44Z" clip-rule="evenodd" fill-rule="evenodd" data-color="1"></path>
                        </g>
                      </svg>
                    </span>
                  </v-row>
                </td>
                <td>Custom alerts</td>
              </tr>
              <tr>
                <td>Custom Fields</td>
                <td v-if='showProPlanBtn'>{{checkUnlimited(plans.pro.limitCustomFields)}}</td>
                <td v-if='showBusinessPlanBtn'>{{checkUnlimited(plans.business.limitCustomFields)}}</td>
                <td v-if='showCompanyPlanBtn'>{{checkUnlimited(plans.company.limitCustomFields)}}</td>
                <td>{{checkUnlimited(plans.corporate.limitCustomFields)}}</td>
              </tr>
              <tr>
                <td>User access rights</td>
                <td v-if='showProPlanBtn'>&mdash;</td>
                <td v-if='showBusinessPlanBtn'>&mdash;</td>
                <td v-if='showCompanyPlanBtn'>
                  <v-row class="justify-center align-center">
                    <span>
                      <svg preserveAspectRatio="xMidYMid meet" data-bbox="0.799 0.761 12.44 9.799" xmlns="http://www.w3.org/2000/svg" viewBox="0.799 0.761 12.44 9.799" height="11" width="14" data-type="color" role="presentation" aria-hidden="true">
                        <g>
                          <path fill="#000624" d="M4.5 8.44 11.94 1A.75.75 0 1 1 13 2.06l-8.5 8.5L1 7.06A.75.75 0 0 1 2.06 6L4.5 8.44Z" clip-rule="evenodd" fill-rule="evenodd" data-color="1"></path>
                        </g>
                      </svg>
                    </span>
                  </v-row>
                </td>
                <td>
                  <v-row class="justify-center align-center">
                    <span>
                      <svg preserveAspectRatio="xMidYMid meet" data-bbox="0.799 0.761 12.44 9.799" xmlns="http://www.w3.org/2000/svg" viewBox="0.799 0.761 12.44 9.799" height="11" width="14" data-type="color" role="presentation" aria-hidden="true">
                        <g>
                          <path fill="#000624" d="M4.5 8.44 11.94 1A.75.75 0 1 1 13 2.06l-8.5 8.5L1 7.06A.75.75 0 0 1 2.06 6L4.5 8.44Z" clip-rule="evenodd" fill-rule="evenodd" data-color="1"></path>
                        </g>
                      </svg>
                    </span>
                  </v-row>
                </td>
              </tr>
              <tr>
                <td>Backup</td>
                <td v-if='showProPlanBtn'>&mdash;</td>
                <td v-if='showBusinessPlanBtn'>&mdash;</td>
                <td v-if='showCompanyPlanBtn'>3 months</td>
                <td>6 months</td>
              </tr>
              <tr>
                <th colspan="5">Integrations</th>
              </tr>
              <tr>
                <td>Integrations</td>
                <td v-if='showProPlanBtn'>&mdash;</td>
                <td v-if='showBusinessPlanBtn'>&mdash;</td>
                <td v-if='showCompanyPlanBtn'>10</td>
                <td>Unlimited</td>
              </tr>
              <tr>
                <td>API access for Integrations</td>
                <td v-if='showProPlanBtn'>&mdash;</td>
                <td v-if='showBusinessPlanBtn'>&mdash;</td>
                <td v-if='showCompanyPlanBtn'>&mdash;</td>
                <td>
                  <v-row class="justify-center align-center">
                    <span>
                      <svg preserveAspectRatio="xMidYMid meet" data-bbox="0.799 0.761 12.44 9.799" xmlns="http://www.w3.org/2000/svg" viewBox="0.799 0.761 12.44 9.799" height="11" width="14" data-type="color" role="presentation" aria-hidden="true">
                        <g>
                          <path fill="#000624" d="M4.5 8.44 11.94 1A.75.75 0 1 1 13 2.06l-8.5 8.5L1 7.06A.75.75 0 0 1 2.06 6L4.5 8.44Z" clip-rule="evenodd" fill-rule="evenodd" data-color="1"></path>
                        </g>
                      </svg>
                    </span>
                  </v-row>
                </td>
              </tr>
              <tr>
                <td>Single Sign On</td>
                <td v-if='showProPlanBtn'>&mdash;</td>
                <td v-if='showBusinessPlanBtn'>&mdash;</td>
                <td v-if='showCompanyPlanBtn'>&mdash;</td>
                <td>
                  <v-row class="justify-center align-center">
                    <span>
                      <svg preserveAspectRatio="xMidYMid meet" data-bbox="0.799 0.761 12.44 9.799" xmlns="http://www.w3.org/2000/svg" viewBox="0.799 0.761 12.44 9.799" height="11" width="14" data-type="color" role="presentation" aria-hidden="true">
                        <g>
                          <path fill="#000624" d="M4.5 8.44 11.94 1A.75.75 0 1 1 13 2.06l-8.5 8.5L1 7.06A.75.75 0 0 1 2.06 6L4.5 8.44Z" clip-rule="evenodd" fill-rule="evenodd" data-color="1"></path>
                        </g>
                      </svg>
                    </span>
                  </v-row>
                </td>
              </tr>
              <tr>
                <th colspan="5">Support</th>
              </tr>
              <tr>
                <td>Assistance</td>
                <td v-if='showProPlanBtn'>&mdash;</td>
                <td v-if='showBusinessPlanBtn'>&mdash;</td>
                <td v-if='showCompanyPlanBtn'>5 hours setup assistance</td>
                <td>20 hours setup assistance</td>
              </tr>
              <tr>
                <td>Phone/Email/Chat Support</td>
                <td v-if='showProPlanBtn'>&mdash;</td>
                <td v-if='showBusinessPlanBtn'>&mdash;</td>
                <td v-if='showCompanyPlanBtn'>&mdash;</td>
                <td>Unlimited</td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-col>
    </v-row>
    <v-row />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  SUBSCRIPTION_PLAN_FREE_ID,
  SUBSCRIPTION_PLAN_BUSINESS_MONTH_ID,
  SUBSCRIPTION_PLAN_BUSINESS_YEAR_ID,
  SUBSCRIPTION_PLAN_COMPANY_MONTH_ID,
  SUBSCRIPTION_PLAN_COMPANY_YEAR_ID,
  SUBSCRIPTION_PLAN_PRO_MONTH_ID,
  SUBSCRIPTION_PLAN_PRO_YEAR_ID,
  SUBSCRIPTION_PLAN_CORPORATE_YEAR_ID
} from '../../constant'
// import service from '@/services/user'

export default {
  name: 'PaymentPlans',
  data() {
    return {
      plans: {
        pro: {},
        business: {},
        company: {},
        corporate: {}
      },
      plansIds: {
        free: SUBSCRIPTION_PLAN_FREE_ID,
        pro: SUBSCRIPTION_PLAN_PRO_YEAR_ID,
        business: SUBSCRIPTION_PLAN_BUSINESS_YEAR_ID,
        company: SUBSCRIPTION_PLAN_COMPANY_YEAR_ID,
        corporate: SUBSCRIPTION_PLAN_CORPORATE_YEAR_ID
      }
    }
  },
  computed: {
    ...mapGetters('user', {
      unpaidError: 'getUnpaidError'
    }),
    currentPlanId() {
      return this.$store.getters['user/getUserPlan']?.id || {}
    },
    isFreePlan() {
      return this.currentPlanId === SUBSCRIPTION_PLAN_FREE_ID
    },
    isProPlan() {
      return this.currentPlanId === SUBSCRIPTION_PLAN_PRO_MONTH_ID || this.currentPlanId === SUBSCRIPTION_PLAN_PRO_YEAR_ID
    },
    isBusinessPlan() {
      return this.currentPlanId === SUBSCRIPTION_PLAN_BUSINESS_MONTH_ID || this.currentPlanId === SUBSCRIPTION_PLAN_BUSINESS_YEAR_ID
    },
    isCompanyPlan() {
      return this.currentPlanId === SUBSCRIPTION_PLAN_COMPANY_MONTH_ID || this.currentPlanId === SUBSCRIPTION_PLAN_COMPANY_YEAR_ID
    },
    isCorporatePlan() {
      return this.currentPlanId === SUBSCRIPTION_PLAN_CORPORATE_YEAR_ID
    },
    showProPlanBtn() {
      return this.isFreePlan || (this.isProPlan && this.unpaidError)
    },
    showBusinessPlanBtn() {
      return this.isFreePlan || this.isProPlan || (this.isBusinessPlan && this.unpaidError)
    },
    showCompanyPlanBtn() {
      return this.isFreePlan || this.isProPlan || this.isBusinessPlan || (this.isCompanyPlan && this.unpaidError)
    },
    showCorporatePlanBtn() {
      return this.isFreePlan || this.isProPlan || this.isBusinessPlan || this.isCompanyPlan || (this.isCorporatePlan && this.unpaidError)
    }
  },
  methods: {
    validate() {},
    checkUnlimited(limit) {
      if (!+limit) return 'Unlimited'
      return +limit
    }
  },
  created() {
    this.$store.dispatch('user/getAllPlans').then(r => {
      this.plans.pro = r.data.data.find(item => item.id === SUBSCRIPTION_PLAN_PRO_MONTH_ID)
      this.plans.business = r.data.data.find(item => item.id === SUBSCRIPTION_PLAN_BUSINESS_MONTH_ID)
      this.plans.company = r.data.data.find(item => item.id === SUBSCRIPTION_PLAN_COMPANY_MONTH_ID)
      this.plans.corporate = r.data.data.find(item => item.id === SUBSCRIPTION_PLAN_CORPORATE_YEAR_ID)
    })
  }
}
</script>

<style scoped lang="scss">
  table {
    width: 100%;
    border-collapse: collapse;
  }

  table tbody tr:hover td {
    background: #f1f3f6 !important;
  }

  th,
  td {
    font-family: inherit;
    font-size: 14px;
    line-height: 1.5;
    color: #444;
    vertical-align: middle;
    padding: 15px 10px;
    width: 20%;
    border: 1px solid #eaeaea;
  }

  /* Tablehead */
  thead {
    th {
      color: #3e3d52;
      text-align: center;
      padding-bottom: 30px;
      font-weight: 400;

      h5 {
        font-size: 20px;
        font-weight: 600;
        margin: 0;
      }

      .paymentPlan__price {
        min-height: 80px;

        .price-wrapper {
          display: flex;
          gap: 5px;
          justify-content: center;
          align-items: center;
          position: relative;
          padding: 10px 0 0;

          span {
            font-size: 20px;
            font-weight: 500;
            line-height: 1;

            &.price {
              font-size: 26px;
              font-weight: 500;
            }

            &.period {
              padding-bottom: 5px;
              font-size: 16px;
            }
          }
        }
        .and-price {
          text-transform: lowercase;
          font-size: 14px;
          padding: 10px 0;
        }
      }
    }
  }

  /* Tablebody */
  tbody {
    tr {
      th {
        font-size: 16px;
        padding-top: 20px;
        text-align: left;
      }
      td {
        text-align: center;

        &:first-child {
          text-align: left;
        }

        .text-light-grey {
          color: rgba(0, 0, 0, 0.2);
        }
      }
    }
  }

  .table-btn {
    font-weight: 500;
    letter-spacing: 1px;
    background: #7671bd;
    color: #fff !important;
    text-decoration: none;
    text-transform: uppercase;
    display: inline-block;
    padding: 10px;
    border-radius: 4px;
    font-size: 1.1em;
    min-width: 140px;
  }
  .table-btn-current-plan {
    background: #f8f8f8;
    font-weight: bold;
    color: #dadada !important;
    text-decoration: none;
    text-transform: uppercase;
    display: inline-block;
    border: solid 1px #dadada;
    padding: 10px;
    min-width: 140px;
    border-radius: 4px;
  }
</style>
